import { SERVICE_NAMES } from '../../../../constants/serviceNames';
import { IPublishTermsServices } from '../../../../redux/reducers';
import { ITermSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { getServiceId } from '../../../../utils/publishTerms';

export function mapServices(terms: Array<ITermSchema>): IPublishTermsServices {
  return terms.reduce((acc, term) => {
    const {
      identificationRequired,
      unavailableReasonType,
      isAdditional,
      incompatibleServices,
      isDefault,
      isAutoProlongAvailable,
      availableActionsCount,
      isAvailable,
      key,
      baseAuctionBet,
      services,
    } = term;

    const serviceId = getServiceId(services);

    acc[serviceId] = {
      id: serviceId,
      name: SERVICE_NAMES[serviceId],
      identificationRequired,
      unavailableReasonType,
      isAdditional,
      incompatibleServices,
      isDefault,
      isAutoProlongAvailable,
      availableActionsCount,
      services,
      isAvailable,
      key,
      baseAuctionBet,
    };

    return acc;
  }, {} as IPublishTermsServices);
}
